"use strict";

// JavaScript Document

$(function () {
$('header .bt_menu').off('click').on('click', function(e){
    e.stopPropagation(); 
		$('header').toggleClass('open');
		$('header .gmenu').fadeToggle(300);
	});
});

/* メインビューのスライドショー */
$(function () {
  $(".slick-wrap").slick({
    fade: true,
    autoplay: true,
    //自動再生
    autoplaySpeed: 5000,
    //自動再生のスピード
    // speed: 2000, //スライドするスピード
    dots: true,
    //スライドしたのドット
    arrows: false,
    //左右の矢印
    infinite: true,
    //スライドのループ
    pauseOnHover: false,
    //ホバーしたときにスライドを一時停止しない
    pauseOnFocus: false //プログレスバーの進捗を実装するため

  });
  $('.slick-dots li button').before('<div class="loading"><svg class="m--sg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20"><path class="path _f -p" d="M10,0.5c5.2,0,9.5,4.3,9.5,9.5s-4.3,9.5-9.5,9.5S0.5,15.2,0.5,10S4.8,0.5,10,0.5" style="stroke-dashoffset: -59.6167; stroke-dasharray: 0px, 999999px;"></path></svg></div>');
  $('path').each(function (i) {
    var $this = $(this);
    var path = this;
    var len = path.getTotalLength(); // lenがパスの長さです。

    $('.path').css({
      'stroke-dasharray': len,
      'stroke-dashoffset': len,
      'fill': 'none',
      'stroke': '#fff'
    });
  }); // path.style.strokeDasharray = pathLength;
  // path.style.strokeDashoffset = pathLength;	
}); //コラムのスライダー

$(function () {
  $('.slider').slick({
    // autoplay:true,
    // autoplaySpeed:5000,
    dots: true,
    slidesToShow: 3,
    arrows: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>',
    // centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: "unslick" // スライダーを無効

    }]
  });
});
$(function () {
  // $('.l_header__humberger').on('click', function () {
  //   $('.l_header__humberger').toggleClass('is-active');
  // 	$("body").toggleClass('is-active');
  // 	$(".l_drawer").toggleClass('is-active');
  // });
  var state = false;
  var pos;
  $('.l_header__humberger').click(function () {
    $('.l_header__humberger').toggleClass('is-active');
    $(".l_drawer").toggleClass('is-active');

    if (state == false) {
      pos = $(window).scrollTop();
      $('body').addClass('fixed').css({
        'top': -pos
      });
      state = true;
    } else {
      $('body').removeClass('fixed').css({
        'top': 0
      });
      window.scrollTo(0, pos);
      state = false;
    }
  });
});
$(function () {
  var bg = $(".top_fixed-bg");
  var header = $('.l_header');
  var headerPage = $('.l_header--page');


  if (bg.length > 0 && consul.length > 0) {

    var el = bg.offset().top;
    var consul = $('.top_consul');
    var consulEl = consul.offset().top;
    var final = consulEl + $(window).height();
  
  
    $(window).scroll(function () {
      var scroll = $(this).scrollTop();
  
      if (scroll > el) {
        bg.css({
          'position': 'fixed',
          'top': '0',
          'left': '0'
        });
        header.addClass('is_active');
      } else {
        bg.css({
          'position': 'absolute',
          'top': '0',
          'left': '0'
        });
        header.removeClass('is_active');
      }
    });
  }
});
$(function () {
  var headerPage = $('.l_header--page'); // let el = bg.offset().top;
  // let consul = $('.top_consul');
  // let consulEl = consul.offset().top;
  // let final = consulEl + $(window).height();

  $(window).scroll(function () {
    var scroll = $(this).scrollTop();

    if (scroll > 50) {
      headerPage.addClass('is_active');
    } else {
      headerPage.removeClass('is_active');
    }
  });
}); // eachTextAnimeにappeartextというクラス名を付ける定義

function EachTextAnimeControl() {
  $('.js_catch-animation').each(function () {
    var elemPos = $(this).offset().top - 50;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("appeartext");
    } else {
      $(this).removeClass("appeartext");
    }
  });
} // 画面をスクロールをしたら動かしたい場合の記述


$(window).scroll(function () {
  EachTextAnimeControl();
  /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

$(window).on('load', function () {
  //spanタグを追加する
  var element = $(".js_catch-animation");
  element.each(function () {
    var text = $(this).text();
    var textbox = "";
    text.split('').forEach(function (t, i) {
      if (t !== " ") {
        if (i < 10) {
          textbox += '<span style="animation-delay:.' + i + 's;">' + t + '</span>';
        } else {
          var n = i / 10;
          textbox += '<span style="animation-delay:' + n + 's;">' + t + '</span>';
        }
      } else {
        textbox += t;
      }
    });
    $(this).html(textbox);
  });
  EachTextAnimeControl();
  /* アニメーション用の関数を呼ぶ*/
}); // .top_consulの画像部分のアニメーション

function topConsulAnime() {
  $('.js_thumb-anime').each(function () {
    var elemPos = $(this).offset().top + 150;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scroll >= elemPos - windowHeight) {
      $(this).addClass("is-active");
    } else {
      $(this).removeClass("is-active");
    }
  });
}

$(window).scroll(function () {
  topConsulAnime();
  /* アニメーション用の関数を呼ぶ*/
});
$(window).on('load', function () {
  topConsulAnime();
  /* アニメーション用の関数を呼ぶ*/
});
// 関連するDL //
var slides_leng = $('.column_dl_slider li').length;
if (slides_leng > 1) {
  $('.column_dl_slider').slick({
    //autoplay: true,
    // autoplaySpeed:5000,
    //dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>',
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      }

    }]
  });
} else {
  $(".column_dl_slider.slick-initialized").slick("unslick");
};

// 関連するセミナー //
var slides_leng = $('.column_seminar_slider li').length;
if (slides_leng > 1) {
  $('.column_seminar_slider').slick({
    //autoplay: true,
    // autoplaySpeed:5000,
    //dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>',
    variableWidth: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      }
    }]
  });
} else {
  $(".column_seminar_slider.slick-initialized").slick("unslick");
};


// 関連するコラム //
$(function () {
  function sliderSetting() {

    var width = $(window).width();

    if (width <= 750) {
      $('.column_column_slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<div class="slide-arrow prev-arrow"></div>',
        nextArrow: '<div class="slide-arrow next-arrow"></div>',
        variableWidth: true,
        centerMode: true,
      });
    } else {
      $('.column_column_slider.slick-initialized').slick('unslick');
    }
  }

  sliderSetting();

  $(window).resize(function () {
    sliderSetting();
  });
});


$(function () {
  let w = $(window).width();
  if (w <= 767) { //window幅が767以下の時
    $(".column_tagitem").each(function (i) {
      if (i > 1) { //iは0が一つ目で、ループ時に+1されるので、3番目以降になります。
        $(this).appendTo(".column_taglist.other"); //li.column_tagitemをul.column_taglist.other内に移動
      }
    });
  } else if (w <= 900) { //window幅が767以下の時
    $(".column_tagitem").each(function (i) {
      if (i > 3) { //iは0が一つ目で、ループ時に+1されるので、5番目以降になります。
        $(this).appendTo(".column_taglist.other"); //li.column_tagitemをul.column_taglist.other内に移動
      }
    });
  }
  else {
    $(".column_tagitem").each(function (i) {
      if (i > 8) {
        $(this).appendTo(".column_taglist.other"); //li.column_tagitemをul.column_taglist.other内に移動
      }
    });
  }
  $('.column_tagitem_other > a').attr('href', 'javascript: void(0)'); //column_tagitem_other > aのリンクを効かなくしてます。
  $('.column_tagitem_other').on('click', function () {
    $('.other_wrap').toggle(500); //.other_wrap出現
  });
});

$('.column_tagitem_other').prependTo('.column_tagitem active');



/* ==========================================================================
   コラム・サービス詳細：目次（TOC）
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
    const contentArea = document.querySelector('.column-cont, .SingleFinancialStrategy');
    if (!contentArea) return;

    let headingSelector = 'h2, h3';
    if (contentArea.classList.contains('SingleFinancialStrategy')) {
        headingSelector = 'h2';
    }

    const headings = contentArea.querySelectorAll(headingSelector);
    const tocContainer = document.getElementById('toc_container');
    const tocList = document.getElementById('toc_list');
    const toggleLink = document.getElementById('toc_toggle_link');

    if (headings.length > 0 && tocContainer) {
        let listHTML = '';

        headings.forEach(function(heading, index) {
            // 見出しにアンカーIDを付与
            const anchorId = 'toc-heading-' + index;
            heading.id = anchorId;

            // 階層（h2=depth_1, h3=depth_2）と番号を取得
            const depth = heading.tagName.toLowerCase() === 'h2' ? '1' : '2';
            const number = index + 1;
            
            listHTML += `<li><a href="#${anchorId}"><span class="toc_number toc_depth_${depth}">${number}</span> ${heading.textContent}</a></li>`;
        });

        tocList.innerHTML = listHTML;

        headings[0].before(tocContainer);

        tocContainer.style.display = 'table';

        const tocLinks = tocList.querySelectorAll('a');
        tocLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault(); 

                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    const isMobile = window.matchMedia('(max-width: 767px)').matches;
                    const headerHeight = (isMobile ? 90 : 134) + 10; 
                    
                    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
                    
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });


    }

    // [hide] / [show] の切り替え（jQueryアニメーション版）
    if (toggleLink) {
        // Vanilla JSのaddEventListenerではなく、jQueryの.on()で記述し直す
        $(toggleLink).on('click', function(e) {
            e.preventDefault();
            
            var $link = $(this);
            var $list = $(tocList);
            
            // CSSのtransitionが設定されていると喧嘩するので無効化
            $list.css('transition', 'none');

            // slideToggleでアニメーション
            $list.stop(true, true).slideToggle(400, function() {
                // アニメーション完了後にテキストを切り替え
                if ($list.is(':visible')) {
                    $link.text('hide');
                } else {
                    $link.text('show');
                }
            });
        });
    }

    // [hide] / [show] の切り替え
    // if (toggleLink) {
    //     toggleLink.addEventListener('click', function(e) {
    //         e.preventDefault();
    //         if (tocList.style.display === 'none') {
    //             tocList.style.display = 'block';
    //             toggleLink.textContent = 'hide';
    //         } else {
    //             tocList.style.display = 'none';
    //             toggleLink.textContent = 'show';
    //         }
    //     });
    // }
});

/* ==========================================================================
   テーブル横スクロールヒント（ScrollHint）
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  const scrollableElements = document.querySelectorAll('.js-scrollable');
  if (scrollableElements.length > 0 && typeof ScrollHint !== 'undefined') {
      new ScrollHint('.js-scrollable');
  }
});